import { BaseFireStore } from './base';

export * from './base';
export * from './interface';
export * from './reatime.db';
export * from './_autos';

export default BaseFireStore;